<template>
<div class="server-error-frame">
	<!-- <div class="server_error_view"> -->
	<img class="server-error-frame-img" src="../../assets/images/server_error.svg"/>
	<!-- </div> -->
	<div class="error-text-holder">
		
		<span class="server-error-header">Nevvon's system is temporarily down.</span>
		<span class="server-error-text">
			We are diligently working to resume our services.<br>
			Sorry for the inconvenience.
		</span>
		<img class="nevvon_logo_text mt-3" src="../../assets/images/nevvon_logo_text.svg"/>


	</div>

</div>

	
</template>
<script>
export default {
	data : function(){
		return{

		}
	}
}
</script>
<style>

.server-error-frame{
	border-radius: 8px;
    border: 1px solid #d7d7d7;
	margin-left: auto;
    margin-right: auto;
	width: 744px;
	height: 544px;
	/* padding: 2rem; */
	text-align: center;
	font-family: "Gilroy Bold", "Gilroy Regular", "Gilroy", sans-serif;
	color: #333333;
	position: relative;
	top: -2rem;
}
.server-error-frame span{
	display: block;
}
.server-error-frame-img{
	width: 380px;
}
.error-text-holder{
	width: 550px;
	margin-left: auto;
	margin-right: auto;
	text-align: left;
}
 .server-error-header{
  font-weight: 700;
  font-size: 28px;
 }
 .server-error-text{
  font-size: 18px;
  line-height: 24px;
 }
.nevvon_logo_text{
	width: 148px;
    height: 25px;
}

</style>


// WEBPACK FOOTER //
// src/components/shared/ServerErrorView.vue